import { render, staticRenderFns } from "./RegisterCounseling.vue?vue&type=template&id=1136f168&"
import script from "./RegisterCounseling.vue?vue&type=script&lang=ts&"
export * from "./RegisterCounseling.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports